// extracted by mini-css-extract-plugin
export var container = "SiteFooter-module--container--7d0e4";
export var funding = "SiteFooter-module--funding--0cf01";
export var inner = "SiteFooter-module--inner--26d04";
export var nav = "SiteFooter-module--nav--c3572";